/*eslint-disable*/
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
// used for making the prop types of this component
import PropTypes from "prop-types";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { useTranslate } from 'react-translate';

// reactstrap components
import { Nav, Collapse, Button } from "reactstrap";

// core components
import { actionLogout } from "store/actions/usersActions";
import Icon from "components/Icons/Icon";
import useAuthorizationValidator from "hooks/useAuthorizationValidator";
import { buildInitials, userAvatarBg, userHasPicture, userPictureUrl, userFullName, userFirstName } from "helpers/userAvatar";


var ps;

const Sidebar = (props) => {
  const [collapseState, setCollapseState] = useState(
    getCollapseStates(props.routes)
  );
  const sidebar = useRef();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userReducer);
  const { checkAccess } = useAuthorizationValidator();

  const handleLogout = async () => {
    await dispatch(actionLogout());
  };

  const t = useTranslate('sidebar');

  useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return () => {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      // to stop the warning of calling setState of unmounted component
      var id = window.setTimeout(null, 0);
      while (id--) {
        window.clearTimeout(id);
      }
    };
  }, [Object.keys(user).length]);

  // this creates the intial state of this component based on the collapse routes
  // that it gets through props.routes
  function getCollapseStates(routes) {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: getCollapseInitialState(prop.views),
          ...getCollapseStates(prop.views),
          ...initialState,
        };
      }
      return null;
    });
    return initialState;
  }
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
  function getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.href.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  }
  // this function creates the links and collapses that appear in the sidebar (left menu)
  function createLinks(routes) {
    return routes.map((prop, key) => {
      if (prop.invisible) {
        return null;
      }

      if (prop.module && !checkAccess(prop.module)) {
        return null;
      }

      //Avoid rendering for a given role
      if (prop.avoid_module && checkAccess(prop.avoid_module)) {
        return null;
      }

      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !collapseState[prop.state];
        return (
          <li
            className={getCollapseInitialState(prop.views) ? "active" : ""}
            key={key}
          >
            <a
              href="#pablo"
              data-toggle="collapse"
              aria-expanded={collapseState[prop.state]}
              onClick={(e) => {
                e.preventDefault();
                setCollapseState({ ...collapseState, ...st });
              }}
            >
              {prop.icon !== undefined ? (
                <>
                  <i className={prop.icon} />
                  <p>
                    {prop.name}
                    <b className="caret" />
                  </p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini-icon">{prop.mini}</span>
                  <span className="sidebar-normal">
                    <p>{t(prop.name.toLowerCase().replace(' ', '-'))}</p>
                    <b className="caret" />
                  </span>
                </>
              )}
            </a>
            <Collapse isOpen={collapseState[prop.state]}>
              <ul className="nav">{createLinks(prop.views)}</ul>
            </Collapse>
          </li>
        );
      }

      return (
        <li className={activeRoute(prop.layout + prop.path)} key={key}>
          <NavLink to={prop.layout + prop.path} activeClassName="">
            {prop.icon !== undefined ? (
              <>
                <i className={prop.icon} />
                <p>{t(prop.name.toLowerCase().replace(' ', '-'))}</p>
              </>
            ) : (
              <>
                <span className="sidebar-mini-icon">{prop.mini}</span>
                <span className="sidebar-normal">{t(prop.name.toLowerCase().replace(' ', '-'))}</span>
              </>
            )}
          </NavLink>
        </li>
      );
    });
  }

  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName) {
    return window.location.href.indexOf(routeName) > -1 ? "active" : "";
  }
  return (
    <>
      <div className="sidebar" data-color={props.backgroundColor}>
        <div className="logo">
          <a href="#" className="simple-text logo-mini">
            <div className="logo-img">
              <Icon file="logo_TP_initials.svg" alt="TS" width="25px" />
            </div>
          </a>
          <a href="#" className="simple-text logo-normal">
            Telepraxen
          </a>
          <div className="navbar-minimize">
            <Button
              outline
              className="btn-round btn-icon"
              color="neutral"
              id="minimizeSidebar"
              onClick={() => props.minimizeSidebar()}
            >
              <i className="now-ui-icons text_align-center visible-on-sidebar-regular" />
              <i className="now-ui-icons design_bullet-list-67 visible-on-sidebar-mini" />
            </Button>
          </div>
        </div>

        <div className="sidebar-wrapper" ref={sidebar}>
          {/* bloque user: avatar, nombre y logout. */}
          <div className="user user-redesign">
            <div
              className="user-avatar"
              style={!userHasPicture(user) ? { background: userAvatarBg(user) } : undefined}
            >
              {userHasPicture(user) ? (
                <img src={userPictureUrl(user)} alt={userFirstName(user) || "User"} />
              ) : (
                <span className="user-avatar-initials">{buildInitials(user)}</span>
              )}
            </div>
            <div className="user-info-block">
              <div className="user-name">
                {user.isAuth ? (userFullName(user) || user.username || "") : ""}
              </div>
              {user.email && <small className="user-email">{user.email}</small>}
            </div>
            <button
              type="button"
              className="user-logout-btn"
              onClick={async (e) => { e.preventDefault(); await handleLogout(); }}
              aria-label="Logout"
              title="Logout"
            >
              <i className="now-ui-icons media-1_button-power" />
            </button>
          </div>
          <Nav>{createLinks(props.routes)}</Nav>
        </div>
      </div>
    </>
  );
};

Sidebar.defaultProps = {
  routes: [],
  showNotification: false,
  backgroundColor: "blue",
  minimizeSidebar: () => {},
};

Sidebar.propTypes = {
  // links that are rendered
  routes: PropTypes.arrayOf(PropTypes.object),
  // if you want to show a notification when switching between mini sidebar and normal
  showNotification: PropTypes.bool,
  // background color for the component
  backgroundColor: PropTypes.oneOf([
    "blue",
    "yellow",
    "green",
    "orange",
    "red",
  ]),
  // function that is called upon pressing the button near the logo
  minimizeSidebar: PropTypes.func,
};

export default Sidebar;
